var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 730,
    height: 400,
    viewBox: "0 0 730 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.00137,
    height: 280,
    fill: "url(#paint0_linear_2010_2013)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.125,
    width: 1.00137,
    height: 310,
    fill: "url(#paint1_linear_2010_2013)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.25,
    width: 1.00137,
    height: 340,
    fill: "url(#paint2_linear_2010_2013)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.375,
    width: 1.00137,
    height: 370,
    fill: "url(#paint3_linear_2010_2013)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.5,
    width: 1.00137,
    height: 400,
    fill: "url(#paint4_linear_2010_2013)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.625,
    width: 1.00137,
    height: 370,
    fill: "url(#paint5_linear_2010_2013)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.75,
    width: 1.00137,
    height: 340,
    fill: "url(#paint6_linear_2010_2013)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.875,
    width: 1.00137,
    height: 310,
    fill: "url(#paint7_linear_2010_2013)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 729,
    width: 1.00137,
    height: 280,
    fill: "url(#paint8_linear_2010_2013)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2010_2013",
    x1: 0.500686,
    y1: 0,
    x2: 0.500686,
    y2: 280,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2010_2013",
    x1: 91.6257,
    y1: 0,
    x2: 91.6257,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2010_2013",
    x1: 182.751,
    y1: 0,
    x2: 182.751,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2010_2013",
    x1: 273.876,
    y1: 0,
    x2: 273.876,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2010_2013",
    x1: 365.001,
    y1: 0,
    x2: 365.001,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2010_2013",
    x1: 456.126,
    y1: 0,
    x2: 456.126,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2010_2013",
    x1: 547.251,
    y1: 0,
    x2: 547.251,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2010_2013",
    x1: 638.376,
    y1: 0,
    x2: 638.376,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2010_2013",
    x1: 729.501,
    y1: 0,
    x2: 729.501,
    y2: 280,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperbg);
export default __webpack_public_path__ + "static/media/upperbg.339d0be63fe16406f0c3495dee1c0db6.svg";
export { ForwardRef as ReactComponent };